import { render, staticRenderFns } from "./UrlExpired.vue?vue&type=template&id=69693223&scoped=true&"
var script = {}
import style0 from "./UrlExpired.vue?vue&type=style&index=0&id=69693223&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69693223",
  null
  
)

export default component.exports